import home1 from "../../assets/img/IMG-20251108-WA0064.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function Softscape() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h4>🌱 What Is Softscape?</h4>
                <p>
                  Softscape is the living heart of every landscape. It’s the
                  plants, the soil, the textures, and the natural colors that
                  bring life and movement into an outdoor space. Where hardscape
                  gives structure, softscape adds soul.
                </p>
                <p>
                  Every leaf, flower, and blade of grass plays a role in shaping
                  the mood of a place. The choice of plants — from tall trees
                  that give shade to ground covers that hold the earth together
                  — defines how the space feels through the seasons. A good
                  softscape design doesn’t just look green; it breathes.
                </p>
                <p>
                  Authentic softscape work begins with understanding the land —
                  its sunlight, soil, and rhythm. The plants you choose should
                  belong to the climate, not fight against it. Native and
                  drought-resistant varieties grow naturally, need less care,
                  and feel more connected to the place.
                </p>
                <p>
                  It’s not about creating a perfect garden; it’s about balance —
                  between color and calm, between growth and space. When
                  designed with care, softscape makes an outdoor area feel
                  peaceful, alive, and truly complete.
                </p>
                <p>
                  In the end, softscape is what makes a landscape feel human. It
                  softens the edges, fills the air with fragrance, and reminds
                  us that beauty grows best when it feels natural.
                </p>
                <p>Softscape includes:</p>
                <ul>
                  <li>🌳 Trees</li>
                  <li>🌷 Flowering plants and shrubs</li>
                  <li>🌾 Grasses and groundcovers</li>
                  <li>🍃 Vines and climbers</li>
                  <li>🌼 Seasonal plants and annuals</li>
                  <li>🍀 Lawns and turf</li>
                  <li>🌴 Palms, ferns, and ornamental foliage</li>
                </ul>
              </div>
              <div className="fisherman-content">
                <h2>🌿 Ready to Refresh Your Landscape?</h2>
                <p>
                  Softscape is what truly{" "}
                  <strong>brings your landscape to life</strong>. From lush
                  lawns to colorful flower beds, we’ll help you design and
                  maintain a vibrant outdoor space that grows more beautiful
                  with every season.
                </p>
                <Link
                  className="commonButton mt-3"
                  href="mailto:info@example.com"
                >
                  📧 Contact Us Today
                </Link>
              </div>
            </div>
          </div>

          <div className="fisherman-content d-none">
            <h4>🌼 Softscape Design Considerations</h4>
            <ul>
              <li>
                Use a mix of perennials and annuals for long-lasting appeal
              </li>
              <li>Plan for bloom sequences to enjoy color year-round</li>
              <li>
                Choose native and drought-resistant plants for sustainability
              </li>
              <li>
                Create layers: tall trees, medium shrubs, and low groundcovers
              </li>
              <li>Ensure compatibility with climate and soil conditions</li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🔄 Softscape vs. Hardscape</h4>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Softscape</th>
                  <th>Hardscape</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Components</td>
                  <td>Plants, soil, grass, flowers</td>
                  <td>Stone, concrete, wood, metal</td>
                </tr>
                <tr>
                  <td>Nature</td>
                  <td>Living, growing, changing</td>
                  <td>Non-living, fixed</td>
                </tr>
                <tr>
                  <td>Maintenance</td>
                  <td>Pruning, watering, fertilizing</td>
                  <td>Cleaning, sealing, repairs</td>
                </tr>
                <tr>
                  <td>Visual Effect</td>
                  <td>Adds softness, color, and motion</td>
                  <td>Adds structure, form, and contrast</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="fisherman-content d-none">
            <h4>🛠️ Our Softscape Services Include:</h4>
            <ul>
              <li>Custom plant selection and layout design</li>
              <li>Garden bed creation and soil preparation</li>
              <li>Tree, shrub, and flower planting</li>
              <li>Lawn installation (sod or seed)</li>
              <li>Mulching and decorative groundcovering</li>
              <li>Seasonal color rotations and upgrades</li>
              <li>Ongoing horticultural maintenance</li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🌟 Benefits of Softscape</h4>
            <ul>
              <li>
                {" "}
                <strong>Enhances Aesthetics</strong> – Adds color, shape, and
                texture
              </li>
              <li>
                {" "}
                <strong>Improves Air Quality</strong> – Plants filter pollutants
                and dust
              </li>
              <li>
                {" "}
                <strong>Cools the Environment</strong> – Reduces heat through
                natural shade
              </li>
              <li>
                {" "}
                <strong>Supports Wildlife</strong> – Provides habitat for birds,
                bees, and butterflies
              </li>
              <li>
                {" "}
                <strong>Creates Seasonal Interest</strong> – Colorful changes
                through the year
              </li>
              <li>
                {" "}
                <strong>Softens Hardscape Elements</strong> – Adds balance and
                flow to structured areas
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Softscape;
